import { Panel, PanelHeaderTemplateOptions } from 'primereact/panel';
import { useTranslation } from "react-i18next";
import { Chip } from "primereact/chip";
import NadaConsta from "../../../../components/nadaConsta";
import { formatValueReais, formatPhoneNumber } from '../../../../utils/ValidationUtils';
import { DataTable } from 'primereact/datatable';
import React from 'react';
import { Column } from 'primereact/column';
import { formatarParaMoedaBRL } from '../../../../utils';
import { Card } from 'primereact/card';
import '../../Protestos.css';

export function ProtestoCenprot({
  data,
}: any) {

  const { t } = useTranslation();
  const getResumoProtesto = () => {
    const resumos: any[] = [];
    if (data.PROTESTO_SINTETICO && data.PROTESTO_SINTETICO.OCORRENCIAS && data.PROTESTO_SINTETICO.OCORRENCIAS.length > 0) {
      resumos.push({
        icon: 'pi pi-chart-line',
        label: 'Quantidade Comarcas',
        value: 0
      })
      resumos.push({
        icon: 'pi pi-gauge',
        label: 'Quantidade Protestos',
        value: 0
      })
      resumos.push({
        icon: 'pi pi-dollar',
        label: 'Valor Total Protestos',
        value: '0'
      })
      let valorTotal = 0.0
      let quantidade = 0;
      const comarcas: any[] = []
      data.PROTESTO_SINTETICO.OCORRENCIAS.forEach((prot: any) => {
        quantidade++;
        valorTotal = valorTotal + Number(prot.VALOR.replace('.', '').replace(',', '.'))
        if (!comarcas.includes(prot.COMARCA)) {
          comarcas.push(prot.COMARCA)
        }
      });
      resumos[0].value = comarcas.length;
      resumos[1].value = quantidade;
      resumos[2].value = formatarParaMoedaBRL(valorTotal);
    }

    return resumos;
  }
  const headerTemplate = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return <div className={className}> {data.PROTESTO_SINTETICO?.OCORRENCIAS && data.PROTESTO_SINTETICO?.OCORRENCIAS.length > 0 ? (<span style={{ color: '#C70039', fontSize: '1.5rem' }} className="pi pi-exclamation-triangle"><span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color: 'black' }}>{t('protestos')}</span></span>) : (<span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color: 'black' }}>{t('protestos')}</span>)} </div>;
  }


  const headerTableTemplate = (protesto: any) => {
    return (
      <React.Fragment>
        <div className="grid">
          <div className="col-12 md:col-6 p-fluid flex flex-wrap">
            <div className="flex flex-column md:flex-row gap-2">
              <label className="label-dados">{t('cartorio')}</label>
              <Chip style={{ width: "100%" }} label={protesto.CARTORIO} />
            </div>
          </div>
          <div className="col-12 md:col-6">
            <div className="flex flex-column md:flex-row gap-2">
              <label className="label-dados">{t('uf')}</label>
              <Chip style={{ width: "100%" }} label={protesto.UF} />
            </div>
          </div>
        </div>
        <div className="grid">
          <div className="col-12 md:col-6 p-fluid flex flex-wrap">
            <div className="flex flex-column md:flex-row gap-2">
              <label className="label-dados">{t('Data Ocorrência')}</label>
              <Chip style={{ width: "100%" }} label={protesto.DATA_OCORRENCIA} />
            </div>

          </div>
          <div className="col-12 md:col-6">
            <div className="flex flex-column md:flex-row gap-2">
              <label className="label-dados">{t('fone')}</label>
              <Chip style={{ width: "100%" }} label={formatPhoneNumber(protesto.TELEFONE)} />
            </div>
          </div>
        </div>
        <div className="grid">
          <div className="col-12 md:col-6 p-fluid flex flex-wrap">
            <div className="flex flex-column md:flex-row gap-2">
              <label className="label-dados">{t('Cedente')}</label>
              <Chip style={{ width: "100%" }} label={protesto.CEDENTE ? protesto.CEDENTE : "N/A"} />
            </div>
          </div>
          <div className="col-12 md:col-6">
            <div className="flex flex-column md:flex-row gap-2">
              <label className="label-dados">{t('Comarca')}</label>
              <Chip style={{ width: "100%" }} label={protesto.COMARCA} />
            </div>
          </div>
        </div>
        <div className="grid">
          <div className="col-12 md:col-6 p-fluid flex flex-wrap">
            <div className="flex flex-column md:flex-row gap-2">
              <label className="label-dados">{t('Info. Cartórios')}</label>
              <Chip style={{ width: "100%" }} label={protesto.INFO_CARTORIOS ? protesto.INFO_CARTORIOS : "N/A"} />
            </div>
          </div>
          <div className="col-12 md:col-6">
            <div className="flex flex-column md:flex-row gap-2">
              <label className="label-dados">{t('Data Atualização')}</label>
              <Chip style={{ width: "100%" }} label={protesto.DATA_ATUALIZACAO ? protesto.DATA_ATUALIZACAO : "N/A"} />
            </div>
          </div>
        </div>
        <div className="grid">
          <div className="col-12 md:col-6 p-fluid flex flex-wrap">
            <div className="flex flex-column md:flex-row gap-2">
              <label className="label-dados">{t('Credor')}</label>
              <Chip style={{ width: "100%" }} label={protesto.CREDOR ? protesto.CREDOR : "N/A"} />
            </div>
          </div>
          <div className="col-12 md:col-6">
            <div className="flex flex-column md:flex-row gap-2">
              <label className="label-dados">{t('endereco')}</label>
              <Chip style={{ width: "100%" }} label={protesto.ENDERECO} />
            </div>
          </div>
        </div>

        <br></br>

      </React.Fragment>
    );
  };
  const agruparPorCartorio = (ocorrencias: any[]) => {
    const grupos: { [key: string]: any[] } = {};
    ocorrencias.forEach((ocorrencia) => {
      if (!grupos[ocorrencia.CARTORIO]) {
        grupos[ocorrencia.CARTORIO] = [];
      }
      grupos[ocorrencia.CARTORIO].push(ocorrencia);
    });
    return grupos;
  };

  const gruposCartorio = data.PROTESTO_SINTETICO?.OCORRENCIAS ? agruparPorCartorio(data.PROTESTO_SINTETICO.OCORRENCIAS) : {};
  return (

    <Panel headerTemplate={headerTemplate} style={{ width: '98%' }}>
      {(!data.PROTESTO_SINTETICO?.OCORRENCIAS || data.PROTESTO_SINTETICO.OCORRENCIAS.length === 0) && (<NadaConsta />)}
      <>
        <div className="protestos-cards">
          {getResumoProtesto().map((item: any, index: number) => (

            <Card className='protestos-card' key={index}>
              <div className="flex-consulta  justify-content-between gap-5">
                <div className="flex-consulta  flex-column gap-1">
                  <span style={{ color: 'white' }} className=" text-sm">{item.label}</span>
                  <span style={{ color: 'white' }} className="font-bold text-lg">{item.value}</span>
                </div>
                <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor: 'white', color: '#183462' }}>
                  <i className={item.icon} />
                </span>
              </div>
            </Card>

          ))}
        </div>
        <br></br>
        {Object.keys(gruposCartorio).map((cartorio, index) => (
          <div key={index}>
            {headerTableTemplate(gruposCartorio[cartorio][0])}
            <DataTable emptyMessage="Nenhuma informação disponível" value={gruposCartorio[cartorio]} responsiveLayout="stack" breakpoint="960px">
              <Column field="DATA_OCORRENCIA" header={t('Data Ocorrência')}></Column>
              <Column header={t('valor')} body={(data) => formatValueReais(data.VALOR)} ></Column>
              <Column field="ANUENCIA" header={t('Carta de anuência')}></Column>
              <Column field="DATA_ATUALIZACAO" header={t('Data Atualização')}></Column>
              <Column field="CEDENTE" header={t('Cedente')}></Column>
              <Column field="CREDOR" header={t('Credor')}></Column>
            </DataTable>
            <br />
          </div>
        ))}
      </>
    </Panel>
  )
}